module.exports = __webpack_public_path__ + "img/menu-logot.87a0844b.png";